export const MAX_STAY_DURATION_DAYS = 30;
